import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function TotalEnergiesRiskDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_totalEnergiesRisk_risk_list"
    />
  );
}
